// components/BusyTimeComponent/DeleteBusyTimeModal.js
import React from "react";
import toast from "react-hot-toast";
import busyTimeApi from "../../api/staff/busyTimeApi";

const DeleteBusyTimeModal = ({ isOpen, onClose, event, onDelete }) => {
  if (!isOpen || !event) return null;

  const handleDelete = async () => {
    try {
      const { response, err } = await busyTimeApi.deleteBusyTime(event.id);
      if (response) {
        toast.success("Busy time deleted");
        onDelete?.(); // refresh busy times
        onClose();
      } else {
        toast.error(err?.response?.data?.message || "Delete failed");
      }
    } catch (error) {
      toast.error("Error deleting busy time");
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded-lg shadow-lg w-80">
        <h3 className="text-lg font-semibold mb-4">Delete Busy Time?</h3>
        <p className="text-sm text-gray-600 mb-6">
          {event.title} <br />
          {event.start.toLocaleTimeString()} – {event.end.toLocaleTimeString()}
        </p>
        <div className="flex justify-end gap-2">
          <button
            className="px-3 py-1 rounded bg-gray-200 text-sm"
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            className="px-3 py-1 rounded bg-red-500 text-white text-sm"
            onClick={handleDelete}
          >
            Delete
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteBusyTimeModal;
